import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

// Compact pill for filter bars: optional leading icon, muted label, active
// value, optional count badge, trailing chevron. `active` highlights it while
// its popover is open; `highlighted` keeps the same look while the chip is
// filtering (value not the default) and closed. Shared by the dashboard chart
// toolbar, the Sessions filter bar and the admin Users toolbar.
export default function FilterChip({ icon: Icon, label, value, badge, onClick, active = false, highlighted = false, title }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-haspopup="true"
      aria-expanded={active}
      className={`inline-flex items-center gap-1.5 h-8 px-2.5 rounded-md border text-xs font-medium transition-colors ${
        active || highlighted
          ? 'border-brand-300 bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:border-brand-700 dark:text-brand-300'
          : 'border-gray-200/70 dark:border-gray-600/70 bg-surface dark:bg-gray-870 text-gray-700 dark:text-gray-200 hover:border-brand-300 hover:bg-brand-50 dark:hover:bg-gray-700'
      }`}
    >
      {Icon && <Icon className="h-3.5 w-3.5 text-gray-400 dark:text-gray-500 flex-shrink-0" />}
      {label && <span className="text-gray-500 dark:text-gray-400">{label}</span>}
      {value && <span className={`font-semibold ${highlighted ? 'text-brand-700 dark:text-brand-300' : 'text-gray-900 dark:text-gray-100'}`}>{value}</span>}
      {badge != null && (
        <span className="ml-0.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-brand-600 dark:bg-brand-500 text-white text-[10px] font-semibold">
          {badge}
        </span>
      )}
      <ChevronDownIcon className="h-3 w-3 text-gray-400 flex-shrink-0" />
    </button>
  );
}
